import ServiceLocator from "../../global/service-locator";
import MobileSearchController from "./mobile-search-controller";

export default class MobileMenu {
    constructor() {
        this.$root = document.getElementById('modal-mobile-menu');
        this.$collapseItemCollection = this.$root.querySelectorAll('.mobile-nav-menu_item.-collapse');

        this.sl = ServiceLocator.instance;
        this.searchController = new MobileSearchController();

        this.init();
    }

    init() {
        this.registerModal();
        this.addEventListeners();
    }

    registerModal() {
        this.sl.modalService.register(
            'mobile-menu',
            document.querySelector('[data-modal-trigger="mobile-menu"]'),
            {
                rootClass: '-mobile-nav'
            }
        );
    }

    addEventListeners() {
        this.itemCollapsingListener();

        this.searchController.subscribe('activeStateChangeEvent', ({ detail: state }) => {
            if (state) {
                this.$root.classList.add('-search');
            } else {
                this.$root.classList.remove('-search');
            }
        });
    }

    itemCollapsingListener() {
        this.$collapseItemCollection.forEach($item => {
            const $trigger = $item.querySelector('.card_header');
            const $collapse = $item.querySelector('.card_collapse');
            const $body = $item.querySelector('.card_body');



            $trigger.addEventListener('click', () => {
                if (!$item.classList.contains('-collapsed')) {
                    const bodyHeight = $body.offsetHeight;

                    $item.classList.add('-collapsed');
                    $collapse.style.maxHeight = bodyHeight + 'px';
                } else {
                    $item.classList.remove('-collapsed');
                    $collapse.style.maxHeight = null;
                }
            });
        });
    }
}